var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionalNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1F82BEC2-0361-4164-86E2-26A0C30E988B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Input-POD-return-address-(LH-POD-booking)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "webapp_add_notes_recipient_1",
    transform: "translate(-474.000000, -806.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(443.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(8.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(10.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0814094,5.05525864 L14.9279941,8.90840101 L8.28757425,15.5601415 C8.26732907,15.5804212 8.24708389,15.6007009 8.20659353,15.6209806 C8.20659353,15.6412603 8.18634834,15.6412603 8.18634834,15.6412603 C8.16610316,15.66154 8.1256128,15.6818197 8.10536761,15.6818197 L8.10536761,15.6818197 L8.08512243,15.6818197 L3.6514275,16.9797203 C3.61093714,17 3.55020159,17 3.50971123,17 C3.36799495,17 3.24652385,16.9594406 3.14529794,16.8580421 C3.02382685,16.7160842 2.9630913,16.533567 3.02382685,16.3510497 L3.02382685,16.3510497 L4.31951852,11.9097961 L4.31951852,11.9097961 L4.31951852,11.8895164 C4.3397637,11.8692367 4.3397637,11.8286773 4.36000888,11.8083976 C4.38025407,11.8083976 4.38025407,11.7881179 4.38025407,11.7881179 L4.38025407,11.7881179 L4.44098961,11.7069992 L11.0814094,5.05525864 Z M5.04834508,13.0251794 L4.25878297,15.7629385 L6.99188259,14.9720303 L5.04834508,13.0251794 Z M12.4580818,3.67623926 C13.4096054,2.72309352 15.1506911,2.78393261 16.1831954,3.81819714 C17.2156997,4.85246167 17.2764352,6.59651559 16.3249116,7.54966134 L16.3249116,7.54966134 L15.6568206,8.21889133 L11.7899908,4.34546926 Z",
    id: "Combined-Shape-Copy"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionalNote);
export default __webpack_public_path__ + "static/media/optional-note.17c5f62e6b6047d5eb1a6b8f8edb2eea.svg";
export { ForwardRef as ReactComponent };